import { NotificationsContainer } from '../NotificationsContainer';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as headerActions from '../../Notifications/store/actions';

const mapState = (state) => state.notifications;

const mapDispatch = (dispatch) => ({
	...bindActionCreators(
		{
			...headerActions,
		},
		dispatch,
	),
});

export const ConnectedNotifications = connect(mapState, mapDispatch)(NotificationsContainer);
